// Lib JS
import { createApp } from 'vue';
import axios from 'axios';
import { createVuetify } from 'vuetify';

// Styles
import 'vuetify/styles'; 
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import '@mdi/font/css/materialdesignicons.css';
import 'aos/dist/aos.css';

// Local JS
import App from './App.vue';
import router from './router';
import store from './store'; // Vuex

// Axios instance configuration
const apiUri = import.meta.env.VITE_APP_API_URI + "api/";
const axiosInstance = axios.create({
    baseURL: apiUri,
    withCredentials: true,
});

// Initialize Vuetify
const vuetify = createVuetify({
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: { mdi },
    },
    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                colors: {
                    'avem': '#ffc451',
                    'note': '#8e8e8e',
                },
            },
        },
    },
    defaults: {
        global: {
            density: 'compact'
        }
    }
});

// Create Vue app
const app = createApp(App);

// Add router, store, Vuetify, and Axios to the app instance
app.use(router);
app.use(store);
app.use(vuetify);
// Provide Axios in the root instance
app.provide('axios', axiosInstance);

// Enable development tools if in development mode
if (import.meta.env.NODE_ENV === 'development') {
    app.config.devtools = true;
    app.config.warnHandler = (msg, vm, trace) => {
        console.warn(`[Vue Warn]: ${msg}\nTrace: ${trace}`);
    };
}

// Silence non-critical third-party browser extension telemetry errors
window.addEventListener('error', (event) => {
    if (event.message && (event.message.includes('reportAllChanges') || event.message.includes("reading 'startTime'"))) {
        event.stopImmediatePropagation();
        event.preventDefault();
        return true;
    }
});

window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && event.reason.message && (event.reason.message.includes('reportAllChanges') || event.reason.message.includes("reading 'startTime'"))) {
        event.stopImmediatePropagation();
        event.preventDefault();
        return true;
    }
});

// Mount the app to the DOM
app.mount('#app');
